import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckLoginGuard } from './guards/check-login.guard';
import { GuestGuard } from './guards/guest.guard';
import * as Highcharts from 'highcharts';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'tabs',loadChildren: './pages/tabs/tabs.module#TabsPageModule',canActivate:[CheckLoginGuard]},
  { path: 'login', loadChildren: './pages/auth/login/login.module#LoginPageModule' , canActivate:[GuestGuard]},
  { path: 'register', loadChildren: './pages/auth/register/register.module#RegisterPageModule', canActivate: [GuestGuard] },
  { path: 'dashboard', loadChildren: './pages/dashboard/dashboard.module#DashboardPageModule', canActivate : [CheckLoginGuard] },
  { path: 'seeds', loadChildren: './pages/seeds/seeds.module#SeedsPageModule' },
  { path: 'seed-point', loadChildren: './pages/seed-point/seed-point.module#SeedPointPageModule' ,canActivate:[CheckLoginGuard]},
  { path: 'ruteros', loadChildren: './pages/ruteros/ruteros.module#RuterosPageModule',canActivate:[CheckLoginGuard] },
  { path: 'splash', loadChildren: './pages/splash/splash.module#SplashPageModule' },
  { path: 'recaudos', loadChildren: './pages/recaudos/recaudos.module#RecaudosPageModule' },
  { path: 'forgot-password', loadChildren: './pages/forgot-password/forgot-password.module#ForgotPasswordPageModule' },
  { path: 'facturacion', loadChildren: './pages/facturacion/facturacion.module#FacturacionPageModule' },
  { path: 'puntos', loadChildren: './pages/puntos/puntos.module#PuntosPageModule' },  { path: 'inventario', loadChildren: './pages/inventario/inventario.module#InventarioPageModule' },
  { path: 'puntos-qr', loadChildren: './pages/puntos-qr/puntos-qr.module#PuntosQrPageModule' },
  { path: 'seed-update', loadChildren: './pages/seed-update/seed-update.module#SeedUpdatePageModule' },
  { path: 'detail-pedido', loadChildren: './pages/detail-pedido/detail-pedido.module#DetailPedidoPageModule' },
  { path: 'usuarios', loadChildren: './pages/usuarios/usuarios.module#UsuariosPageModule' },
  { path: 'comunicaciones', loadChildren: './pages/comunicaciones/comunicaciones.module#ComunicacionesPageModule' },
  { path: 'franjas', loadChildren: './pages/franjas/franjas.module#FranjasPageModule' },
  { path: 'terms', loadChildren: './pages/auth/terms/terms.module#TermsPageModule' },
  { path: 'operaciones', loadChildren: './pages/operaciones/operaciones.module#OperacionesPageModule' },


 





];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
